module.exports = __webpack_public_path__ + "static/img/M-5.15b9a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/M-5.png
// module id = LxvM
// module chunks = 0